import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";

export function IndicadoresHeader({
  total,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Indicadores de impuesto"
      description={`${total} indicadores · códigos SAP (V0/V5/V7) usados para prellenar el prorrateo, conciliar Órdenes de Compra y Contratos Anualizados, y calcular el IVA de cada renglón de la póliza.`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo indicador
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
